import { ACTIONS } from "./actions";




const initialState = {
  reportData: null,
  reportLoader: true
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case ACTIONS.SET_REPORT_LOADING:
      return {
        ...state,
        reportLoader: true
      };
    case ACTIONS.SET_REPORT_DATA:
      return {
        ...state,
        reportData: payload,
        reportLoader: false
      };
    case ACTIONS.SET_ERROR:
      return {
        ...state,
        ...payload
      };
    default:
      return state;
  }
};

export default reducer;
